const translations = {
    noChangesToSave: 'There are no changes to be saved.',
    roles: 'Roles',
    save: 'Save',
    title: 'My Information'
};

export default translations;
